export const SUGGEST_RESULT_SIZE = "64px";
